.menuWrapper {
  top: 50px !important;
  -webkit-filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.32));
  filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.32));
}
